import BaseService from "../index";

export default {
    get() {
        return BaseService.get(`/cms/product-page`);
    },

    update(params) {
        return BaseService.put(`/cms/product-page`, params);
    },
};
